import { eligibilityStoreProps } from "../../store/eligibilityData";
import { BusinessApplicationId, ClentAnonId } from "../utils/types";

export interface saveInterviewPayload {
  id: string;
  payload: {
    prompt: string;
    countDown?: string;
  };
}

export interface saveBusinessInterviewPayload extends saveInterviewPayload {
  sessionCount: number;
}

export interface GetInterviewHistoryRes {
  hasError: boolean;
  code: number;
  result: string | GetInterviewHistoryResult[];
}

export interface GetBusinessInterviewHistoryRes extends GetInterviewHistoryRes {
  sessionCompleted: boolean;
}

export interface saveBusinessInterviewTimeoutPayload {
  sessionCount: string;
  businessId: string;
}

export interface PostRiskAssessmentRes {
  hasError: boolean;
  code: number;
  result: string;
  // result: {
  //   role: string;
  //   content: string;
  //   refusal: null;
  // };
}

export enum GetInterviewHistoryResultRole {
  user = "user",
  assistant = "assistant",
}

export interface GetInterviewHistoryResult {
  content: string;
  role: GetInterviewHistoryResultRole;
}

// export interface GetInterviewHistoryResult {
//   parts: GetInterviewHistoryPart[];
//   role: string;
// }

// export interface GetInterviewHistoryPart {
//   text: string;
// }

export interface RiskAssessmentGenericDS160
  extends RiskAssessmentPersonalInfoPayload {}

export interface RiskAssessmentDS160 {
  errorCheck?: boolean;
}

export interface AssessmentDs160Payload {
  data: Partial<AssessmentDs160DataPayload>;
  errorCheck?: boolean;
}

export interface AssessmentDs160DataPayload
  extends RiskAssessmentPersonalInfoPayload,
    RiskAssessmentGenericDS160,
    AssessmentDs160TravelPayload,
    AssessmentDs160AddressPhonePayload,
    AssessmentDs160PassportPayload,
    AssessmentDs160USContactPayload,
    AssessmentDs160FamilyPayload,
    AssessmentDs160WETPayload,
    AssessmentDs160SevisPayload,
    AssessmentDs160SecurityPayload,
    BusinessApplicationId,
    ClentAnonId {}

export interface RiskAssessmentPersonalInfoPayload {
  personal_Info: Record<string, string>;
}

export interface AssessmentDs160TravelPayload {
  travel: Record<string, string>;
}

export interface AssessmentDs160AddressPhonePayload {
  address_phone: Record<string, string>;
}

export interface AssessmentDs160PassportPayload {
  passport: Record<string, string>;
}

export interface AssessmentDs160USContactPayload {
  us_contact: Record<string, string>;
}

export interface AssessmentDs160FamilyPayload {
  family: Record<string, string>;
}

export interface AssessmentDs160WETPayload {
  wet: Record<string, string>;
}

export interface AssessmentDs160SevisPayload {
  sev: Record<string, string>;
}

export interface AssessmentDs160SecurityPayload {
  security: Record<string, string>;
}

export interface GetChatGptDs160AssessmentRes {
  hasError: boolean;
  code: number;
  result: string;
  // result: {
  //   role: string;
  //   content: string;
  //   refusal: null;
  // };
}

export interface EligibilityCountryApprovalRatePayload {
  data: string;
}

export interface EligibilityAnalysisPayload {
  data: eligibilityStoreProps;
}

export interface FibiInterviewFeedbackPayload {
  businessId?: string;
  sessionCount: number;
  rating: number;
  comment: string;
  source: string;
}

export interface SendPromptToStream {
  prompt: string;
  onStreamData?: (chunk: string) => void;
  onStreamAudio?: (base64Audio: string) => void;
  onStreamEnd?: () => void;
}

export interface SendPromptToStreamBusiness extends SendPromptToStream {
  sessionCount: number;
  id: string;
  countDown: string;
}

export interface saveUserInterviewTimeoutPayload {
  sessionCount: string;
}

export interface userInitializeInterviewPayload {
  sessionCount: number;
}

export interface InterviewsResponse {
  interviewNo: number;
  status: "COMPLETED";
}

export interface UploadFibiDs160Res {
  hasError: boolean;
  code: number;
  isContentValid: boolean;
  url: string;
  message: string;
}

interface SessionData {
  date: string;
  duration: string;
  totalQuestions: number;
  interviewType: string;
  overallScore: number;
  summary: string;
}

interface ResponseInsight {
  question: string;
  score: number;
  feedback: string;
}

interface TopicProficiency {
  topic: string;
  subText: string;
  score: number;
  questionsAsked: number;
  strengths?: string[];
  improvements?: string[];
}

export interface GetSessionAnalysisRes {
  sessionData: SessionData;
  strongestResponses?: ResponseInsight[];
  topicProficiencies?: TopicProficiency[];
  weakestResponses?: ResponseInsight[];
}

export interface GetAllSession {
  id: number;
  date: string;
  duration: string;
  interviewType: string;
  overallScore: number;
  summary: string;
}

export interface AnonUserInterviewPayload {
  id?: string;
  payload?: {
    userMessage: string;
  };
}

export interface AnonUserInterviewRes {
  hasError: false;
  code: 201;
  data: string;
  id: string;
}
